export const stockViewEjs= `<div class="someStyle" id="stockShow">
    <h2><%= stockSymbol%></h2>
    <div><label>Price:</label><p><%= price%></p></div>
    <div><label>Date:</label><p><%= date%></p></div>
    <div><label>High:</label><p><%= high%></p></div>
    <div><label>Low:</label><p><%= low%></p></div>
    <div><label>Change:</label><p><%= change%></p></div>
</div>`


